import type { LandingPageCtaMode } from '@provision/landing-page-utils';

const COUNT_WORDS = [
  'Zero',
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
  'Seven',
  'Eight',
  'Nine',
];

function plansHeadline(count: number): string {
  let lead = 'Memberships.';
  if (count === 1) lead = 'One membership.';
  else if (count > 1) lead = `${COUNT_WORDS[count] ?? String(count)} memberships.`;

  return `${lead} *One promise:* it just works.`;
}

/** Copy the Content tab does not own yet, taken from the mockup. Each becomes a field the day the editor grows it. */
export const COPY = {
  heroEyebrow: 'Premium Support Memberships',
  compareMemberships: 'Compare memberships',
  savingsNote: (pct: number) => `Save ${pct}% on any membership with annual billing`,
  playVideo: 'Play video',

  plansKicker: 'Choose your experience',
  plansHeadline,
  plansLede:
    'Every tier includes 24/7/365 access to our remote support team. From there, pick how proactive you want us to be.',
  monthly: 'Monthly',
  annual: 'Annual',
  saveChip: (pct: number) => `Save ${pct}%`,
  perMonth: '/ month',
  billedMonthly: 'Billed monthly. Cancel anytime.',
  billedAnnually: (pct: number | null) =>
    pct === null ? 'Billed annually.' : `Billed annually. ${pct}% savings applied.`,
  callForPricing: 'Call for pricing',
  tailored: (name: string) => `We'll tailor ${name} to your home.`,
  callPhone: (phone: string) => `Call ${phone}`,
  everythingIn: (name: string) => `Everything in ${name}`,
  responseWithin: (minutes: number) => `Response within ${minutes} min`,
  mostPopular: 'Most popular',
  plansFoot: 'Plans and features stay in sync with your membership agreement, automatically.',

  faqKicker: 'Questions, answered',
  faqHeadline: 'Frequently asked *questions*',

  viewPlans: 'View plans',

  ctaLabel: {
    consultation: 'Schedule a Consultation',
    signup: 'Get Started',
  } satisfies Record<LandingPageCtaMode, string>,

  navMemberships: 'Memberships',
  navFaq: 'FAQ',
  textOrCall: (phone: string) => `Text or call ${phone}`,
  terms: 'Terms of Service',
  copyright: (year: number, name?: string) =>
    `© ${year}${name ? ` ${name}` : ''}. All rights reserved.`,
  poweredBy: 'Powered by',
  provision: 'ProVision',
};
